<template>
  <nav>
    <v-navigation-drawer
      v-if="$store.getters['user/isLogged']"
      v-model="drawer"
      class="teal lighten-5"
      width="320"
      disable-resize-watcher
      app
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="display-2">mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{$store.getters['user/company']}}</v-list-item-title>
            <v-list-item-subtitle>{{$store.getters['user/name']}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-row>
              <v-col>
                <span>{{$t('label.tarif')}}</span>
              </v-col>
              <v-col class="text-right">
                <v-icon color="green" class="mr-2">mdi-email-outline</v-icon>
                <span>{{$store.getters['user/tarif'] | currency4}}</span>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mb-5"></v-divider>
        <v-list-item-group>
          <template v-for="item in upperMenu">
            <v-list-item link :key="item.text" class="hidden-md-and-up" :to="item.route">
              <v-list-item-icon>
                <v-icon>{{item.icon}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('menu.'+item.text)}}</v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item v-if="$store.getters['user/isAdmin']" to="/admin">
            <v-list-item-icon>
              <v-icon>mdi-cogs</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{$t('menu.admin')}}</v-list-item-content>
          </v-list-item>
          <v-list-item @click="logoff">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{$t('menu.logout')}}</v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider class="mb-5"></v-divider>
      <SelectLocale />
    </v-navigation-drawer>

    <v-app-bar v-if="$store.getters['user/isLogged']" app dark class="primary">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <i18n path="title.main" class="hidden-sm-only"></i18n>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-for="item in upperMenu">
        <v-btn text class="ml-2 hidden-sm-and-down" :key="item.text" :to="item.route">
          <v-icon class="mr-3">{{ item.icon }}</v-icon>
          {{$t('menu.'+item.text)}}
        </v-btn>
      </template>
      <v-btn icon to="/">
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </v-app-bar>
  </nav>
</template>
<script>
import SelectLocale from "@/components/Select-locale";

export default {
  components: { SelectLocale },
  name: "AppHeader",
  data() {
    return {
      drawer: false,
      upperMenu: this.$api.upper_menu
    };
  },
  computed: {},
  mounted() {
    this.$root.$on("SetHeaderTitle", arg1 => {
      console.log(arg1);
    });
  },

  methods: {
    async logoff() {
      await this.$store.dispatch("user/LOGOUT");
      this.$router.push("/login");
    }
  }
};
</script>
<style scoped>
</style>
